import { DashboardContent, SideMenu } from '@fukuri-admins/ui/common';
import { getEmail } from '@fukuri-admins/utils/common/cookies';
import { ComponentProps } from 'react';
import { Outlet } from 'react-router-dom';
import ADMIN_ICON from '~/assets/icons/admin.svg';
import TOP_BANNER_ICON from '~/assets/icons/banner.svg';
import BELL_ICON from '~/assets/icons/bell.svg';
import CLIENT_ICON from '~/assets/icons/client.svg';
import GROUP_ICON from '~/assets/icons/group.svg';
import REPORT_ICON from '~/assets/icons/report.svg';
import SERVICE_ICON from '~/assets/icons/service.svg';
import USER_ICON from '~/assets/icons/user.svg';
import { useAuth } from '~/components/auth/AuthProvider';
import { useConfiguration } from '~/contexts/ConfigurationProvider';
import {
  getClientAdminUsersLink,
  getClientContractListLink,
  getClientsLink,
  getContractPlansLink,
  getGroupsLink,
  getLoginReportLink,
  getPushNotificationLink,
  getServiceReportLink,
  getServicesLink,
  getTopBannersLink,
  getUsersLink,
} from '~/utils/getLinks';
import styles from './styles.module.scss';

const BASE_SIDE_MENU_ITEMS: ComponentProps<typeof SideMenu>['menus'] = [
  {
    icon: <img src={CLIENT_ICON} alt='利用企業一覧' />,
    content: '利用企業一覧',
    link: getClientsLink(),
  },
  {
    icon: <img src={USER_ICON} alt='利用者一覧' />,
    content: '利用者一覧',
    link: getUsersLink(),
  },
  {
    icon: <img src={ADMIN_ICON} alt='利用企業管理者一覧' />,
    content: '利用企業管理者一覧',
    link: getClientAdminUsersLink(),
  },
  {
    icon: <img src={GROUP_ICON} alt='グループ一覧' />,
    content: 'グループ一覧',
    link: getGroupsLink(),
  },
  {
    icon: <img src={SERVICE_ICON} alt='契約プラン' />,
    content: '契約プラン',
    link: getContractPlansLink(),
  },
  {
    icon: <img src={REPORT_ICON} alt='企業契約期間' />,
    content: '企業契約期間',
    link: getClientContractListLink(),
  },
  {
    icon: <img src={SERVICE_ICON} alt='サービス一覧' />,
    content: 'サービス一覧',
    link: getServicesLink(),
  },
  {
    icon: <img src={TOP_BANNER_ICON} alt='キャンペーンバナー管理' />,
    content: 'キャンペーンバナー管理',
    link: getTopBannersLink(),
  },
  {
    icon: <img src={BELL_ICON} alt='プッシュ通知' />,
    content: 'プッシュ通知',
    link: getPushNotificationLink(),
  },
  {
    icon: <img src={REPORT_ICON} alt='レポート' />,
    content: 'レポート',
    subMenus: [
      {
        content: 'サービス利用履歴',
        link: getServiceReportLink(),
      },
      {
        content: 'ログイン履歴',
        link: getLoginReportLink(),
      },
    ],
  },
];

/**
 * 既存画面向けのレガシーレイアウト
 * SideMenu / DashboardContent を含む従来の構成を維持する
 */
export const LegacyDashboardLayout: React.FC = () => {
  const { applicationConfiguration } = useConfiguration();

  const email = getEmail();
  const { signOut } = useAuth();

  return (
    <div className={styles.LegacyDashboardLayout}>
      <SideMenu
        imageUrl={applicationConfiguration?.application_configuration.logo_image.url}
        menus={BASE_SIDE_MENU_ITEMS}
        displayName={email}
        signOut={signOut}
      >
        <div className={styles.LegacyDashboardLayout__SideMenuFooter}>
          {applicationConfiguration?.application_configuration.application_name} 管理者
        </div>
      </SideMenu>
      <DashboardContent
        copyrightCompanyName={applicationConfiguration?.application_configuration?.partner?.name}
      >
        <Outlet />
      </DashboardContent>
    </div>
  );
};
